import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const landingPageEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-assets-landing-page-entrypoint" */ './index.tsx'),
	),
	getPreloadProps: () => ({}),
});
